import { styles, variants, TooltipContentTheme } from '../TooltipContentStyles.css';
import { baseTheme } from './TooltipContentBaseTheme.css';
import { multiVariantStyles } from './TooltipContentVariants.css';

/*******************
 * Component Theme
 *******************/

const TooltipContentRedwoodTheme: TooltipContentTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TooltipContentRedwoodTheme };
